<template>
    <div class="components-container">
        <div class="filter-container">
            <el-select v-model="queryForm.Xnxqbm" filterable placeholder="学年学期" style="width:220px" clearable>
                <el-option v-for="item in xnxqInfo" :key="item.comboValue" :label="item.comboName"
                           :value="item.comboValue">
                </el-option>
            </el-select>
            <el-select v-model="queryForm.Xbdm" filterable placeholder="系部名称" style="width:180px" @change="deptChange"
                       clearable>
                <el-option v-for="item in deptInfo" :key="item.comboValue" :label="item.comboName"
                           :value="item.comboValue">
                </el-option>
            </el-select>
            <el-select v-model="queryForm.Zydm" filterable placeholder="专业名称" style="width:180px" clearable>
                <el-option v-for="item in majorInfo" :key="item.comboValue" :label="item.comboName"
                           :value="item.comboValue">
                </el-option>
            </el-select>
            <el-input v-model="queryForm.Bjjc" @keyup.enter.native="handleFilter" style="width: 180px"
                      placeholder="班级简称" clearable>
            </el-input>
            <el-select v-model="queryForm.Zxqkshzt" filterable placeholder="审核状态" style="width:150px" clearable>
                <el-option v-for="item in zxqkshztInfo" :key="item.comboValue" :label="item.comboName"
                           :value="item.comboValue">
                </el-option>
            </el-select>
            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询
            </el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button @click="showExport" type="primary" style="margin-left: 10px;"><i class="el-icon-document">&nbsp;导出</i>
            </el-button>
            <el-button @click="courseInfoExportDialogVisible = true" type="primary" style="margin-left: 10px;"><i
                class="el-icon-document">&nbsp;课程信息导出</i></el-button>
        </div>

        <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading"
                  :cell-style="handleCellStyle"
                  element-loading-text="信息加载中" highlight-current-row border style="width: 100%"
                  :height="mainTableHeight" ref="mainTable">
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{ (currentPage - 1) * limit + scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="学年学期" prop="xnxqmc" align="center" min-width="22%"></el-table-column>
            <el-table-column label="专业名称" prop="zymc" align="center" min-width="22%"></el-table-column>
            <el-table-column label="班级简称" prop="bjjc" align="center" min-width="22%"></el-table-column>
            <el-table-column label="审核状态" prop="zxqkshzt" :formatter="auditStateFormatter" align="center"
                             min-width="22%"></el-table-column>
            <el-table-column label="操作" align="center" min-width="12%">
                <template slot-scope="scope">
                    <el-button size="small" @click="showKKJHInfo(scope.row);" type="primary">
                        <i class="el-icon-tickets"></i>&nbsp;详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange"
                           :current-page.sync="currentPage"
                           :page-sizes="[10, 20, 50]" :page-size="limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>

        <!-- 班级开课计划详情 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @closed="closeDialog" width="1000px" top="150px">
            <div class="dialog-footer" style="margin-bottom: 10px">
                <el-button v-if="auditAuth == '1'" size="medium" @click="auditRec();" type="warning">
                    <i class="el-icon-edit-outline"></i>&nbsp;审核
                </el-button>
                <el-button size="medium" @click="showAuditList();">
                    <i class="el-icon-document-copy"></i>&nbsp;审核信息
                </el-button>
            </div>
            <el-table :data="kkjhData" @current-change="kkjhCurrentChange" v-loading.body="tableLoading"
                      class="kkjhTable"
                      element-loading-text="信息加载中" highlight-current-row border style="width: 100%" height="560px"
                      ref="kkjhTable">
                <el-table-column label="序号" width="50" align="center">
                    <template slot-scope="scope">
                        <span>{{ (kkjhcurrentPage - 1) * kkjhlimit + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="课程名称" prop="kcmc" align="center" min-width="18%"></el-table-column>
                <el-table-column label="节数" prop="js" align="center" min-width="10%"></el-table-column>
                <!-- <el-table-column label="固排已排节数" prop="gpypjs" align="center" min-width="10%"></el-table-column> -->
                <el-table-column label="实际已排节数" prop="sjypjs" align="center" min-width="10%"></el-table-column>
                <el-table-column label="未排节数" prop="wpjs" align="center" min-width="10%"></el-table-column>
                <el-table-column label="授课教师" prop="skjsxm" align="center" min-width="17%"></el-table-column>
                <el-table-column label="使用教室" prop="cdmc" align="center" min-width="17%"></el-table-column>
                <el-table-column label="授课周次" prop="skzc" align="center" min-width="17%"></el-table-column>
                <el-table-column label="是否排课" prop="sfpk" align="center" min-width="10%"></el-table-column>
            </el-table>
            <div style="width:100%;height:20px;">
            </div>
        </el-dialog>

        <!-- 审核dialog -->
        <el-dialog :title="detailDialogTitle" :visible.sync="detailDialogVisible" v-if="detailDialogVisible"
                   width="640px" :top="detailDialogTop">
            <el-form label-width="120px" label-position="left" width="100%">
                <el-row v-show="auditAreaVisible">
                    <el-col :span="24">
                        <audit ref="audit" :itemCode="auditParam" :relatedCode="skjhzbbh" :auditLevel="auditLevel"
                               @auditCallback="auditCallback"></audit>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <!-- 审核信息dialog -->
        <el-dialog title="审核信息" :visible.sync="auditListDialogVisible" v-if="auditListDialogVisible" width="900px"
                   top="150px">
            <div style="height:600px;">
                <auditList ref="auditList" :relatedCode="skjhzbbh" :listHeight="500"></auditList>
            </div>
        </el-dialog>

        <!-- 导出dialog -->
        <el-dialog title="导出开课计划执行情况" :visible.sync="exportDialogVisible" @closed="closeExportDialog" width="800px"
                   top="240px">
            <!-- 遮罩层 -->
            <div id="loadingMask" class="maskStyle">
                <div class="maskFont">开课计划执行情况导出中，请稍后...</div>
            </div>
            <el-form :model="exportForm" ref="exportForm" label-width="130px" label-position="left" width="100%">
                <el-row>
                    <el-form-item label="学年学期" prop="Xnxqbm">
                        <el-select v-model="exportForm.Xnxqbm" placeholder="学年学期" style="width: 100%;">
                            <el-option v-for="(item, index) in xnxqInfo" :key="item.comboValue" :label="item.comboName"
                                       :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>

                <el-row>
                    <el-form-item label="系部名称" prop="Xbdm">
                        <el-select v-model="exportForm.Xbdm" placeholder="全部" style="width: 100%;" @change="deptChange"
                                   multiple clearable>
                            <el-option v-for="(item, index) in deptInfo" :key="item.comboValue" :label="item.comboName"
                                       :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="专业名称" prop="Zydm">
                        <el-select v-model="exportForm.Zydm" placeholder="全部" style="width: 100%;" @change="majorChange"
                                   multiple clearable>
                            <el-option v-for="(item, index) in majorInfo" :key="item.comboValue" :label="item.comboName"
                                       :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="班级名称" prop="Bjdm">
                        <el-select v-model="exportForm.Bjdm" placeholder="全部" style="width: 100%;" multiple clearable>
                            <el-option v-for="(item, index) in classInfo" :key="item.comboValue" :label="item.comboName"
                                       :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="teachingPlanExport" type="primary" style="margin-left: 10px;"><i
                    class="el-icon-document">&nbsp;导出</i></el-button>
            </div>
        </el-dialog>


        <el-dialog title="课程信息导出" :visible.sync="courseInfoExportDialogVisible" width="800px" @closed="closeCourseInfoExport">
            <!-- 遮罩层 -->
            <div id="loadingMask" class="maskStyle">
                <div class="maskFont">课程信息导出中，请稍后...</div>
            </div>
            <el-form :model="courseInfoExportForm" ref="courseInfoExportForm" label-width="80px" label-position="left"
                     width="100%">
                <el-row>
                    <el-form-item label="学年" prop="Xn" :rules="[{required: true, message: '请选择学年'}]">
                        <el-select v-model="courseInfoExportForm.Xn" placeholder="学年" style="width: 100%;">
                            <el-option v-for="(item, index) in xnInfo" :key="item.comboValue" :label="item.comboName"
                                       :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>

                <el-row>
                    <el-form-item label="学期" prop="Xq">
                        <el-select v-model="courseInfoExportForm.Xq" placeholder="全部" style="width: 100%;" clearable>
                            <el-option v-for="(item, index) in xqInfo" :key="item.comboValue" :label="item.comboName"
                                       :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="学制" prop="Xz">
                        <el-select v-model="courseInfoExportForm.Xz" placeholder="全部" style="width: 100%;" clearable>
                            <el-option v-for="(item, index) in xzInfo" :key="item.comboValue" :label="item.comboName"
                                       :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="系部名称" prop="Xbdm">
                        <el-select v-model="courseInfoExportForm.Xbdm" placeholder="全部" style="width: 100%;"
                                   @change="loadExportClassCombo('dept')" multiple clearable filterable>
                            <el-option v-for="(item, index) in courseInfoExportComboOption.dept" :key="item.comboValue" :label="item.comboName"
                                       :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="专业名称" prop="Zydm">
                        <el-select v-model="courseInfoExportForm.Zydm" placeholder="全部" style="width: 100%;"
                                   @change="loadExportClassCombo" multiple clearable filterable>
                            <el-option v-for="(item, index) in courseInfoExportComboOption.major" :key="item.comboValue" :label="item.comboName"
                                       :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="年级名称" prop="Njdm">
                        <el-select v-model="courseInfoExportForm.Njdm" placeholder="全部" style="width: 100%;"
                                   @change="loadExportClassCombo" multiple clearable filterable>
                            <el-option v-for="(item, index) in courseInfoExportComboOption.grade" :key="item.comboValue" :label="item.comboName"
                                       :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="班级名称" prop="Bjdm">
                        <el-select v-model="courseInfoExportForm.Bjdm" placeholder="全部" style="width: 100%;" multiple filterable
                                   clearable>
                            <el-option v-for="(item, index) in courseInfoExportComboOption.class" :key="item.comboValue" :label="item.comboName"
                                       :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="courseInfoExport" type="primary" style="margin-left: 10px;"><i
                    class="el-icon-document">&nbsp;导出</i></el-button>
            </div>
        </el-dialog>


    </div>
</template>
<script>
import {confirmMsg, showNotify} from "utils/message";
import audit from 'views/audit/audit.vue';
import auditList from 'views/audit/auditList.vue';

export default {
    components: {
        audit,
        auditList,
    },
    data() {
        return {
            comboData: {
                changeCode: null,
                major: null,
                class: null,
            },
            queryForm: {
                pageNum: 1,
                rowNum: 10,
                Xnxqbm: null,
                Xnxqmc: null,
                Bjdm: '',
                Bjmc: '',
                Zydm: '',
                Zymc: '',
                Xbdm: '',
                Xbmc: '',
                Shzt: null,
                Zxqkshzt: null,
            },
            xnxqInfo: [], //学年学期下拉框
            deptInfo: [], //系部下拉框
            majorInfo: [], //专业下拉框
            gradeInfo: [], //年级下拉框
            classInfo: [], //班级下拉框
            zxqkshztInfo: [], //执行情况审核状态下拉框
            tableData: [],
            kkjhData: [],
            currentPage: 1,
            limit: 10,
            kkjhcurrentPage: 1,
            kkjhlimit: 10,
            total: null,
            tableLoading: true,
            selectRowData: null,
            mainTableHeight: 500,
            dialogTitle: "",
            dialogVisible: false,
            fieldVisible: false,
            schoolVisible: false,
            majorVisible: false,
            classVisible: false,
            skjhzbbh: '',
            auditLevel: null,
            auditState: null,
            auditAuth: null,
            formSubmiting: false,
            detailDialogTitle: '',
            detailDialogTop: '150px',
            detailDialogVisible: false,
            auditAreaVisible: false,
            auditListDialogVisible: false,
            auditParam: null,
            numarray: [],
            totalLevel: null,

            exportDialogVisible: false,
            exportForm: {
                Xnxqbm: null,
                Xnxqmc: null,
                Xbdm: '',
                Zydm: '',
                Bjdm: '',
            },

            courseInfoExportDialogVisible: false,
            courseInfoExportForm: {
                Xn: '',
                Xq: '',
                Xz: '',
                Xbdm: '',
                Zydm: '',
                Njdm: '',
                Bjdm: ''
            },
            xnInfo: [],
            xqInfo: [
                {'comboValue': '1', 'comboName': '上学期'},
                {'comboValue': '2', 'comboName': '下学期'}
            ],
            xzInfo: [
                {'comboValue': '3', 'comboName': '三年制'},
                {'comboValue': '5', 'comboName': '五年制'}
            ],
            courseInfoExportComboOption:{
                dept:[],
                major:[],
                grade:[],
                class:[]
            }
        };
    },
    created() {
        this.initParam();
    },
    mounted() {
        this.numarray = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
        this.zxqkshztInfo = [{"comboValue": "0", "comboName": "待审核"}, {
            "comboValue": "1",
            "comboName": "审核中"
        }, {"comboValue": "2", "comboName": "审核通过"}, {"comboValue": "3", "comboName": "审核驳回"}];
        this.queryAuditParam();

        this.$nextTick().then(() => {
            //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
            //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
            this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;

            // 监听窗口大小变化
            let self = this;
            window.onresize = function () {
                self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
            };
        });
    },
    methods: {
        closeCourseInfoExport(){
            if(this.$refs['courseInfoExportForm'] !== undefined){
                this.$refs['courseInfoExportForm'].clearValidate();
                this.$refs['courseInfoExportForm'].resetFields();
            }
            this.loadExportClassCombo();
        },
        loadExportClassCombo(type) {
            this.courseInfoExportForm.Bjdm = []
            let formData = new FormData();
            formData.append('deptCode', this.courseInfoExportForm.Xbdm);

            if(type === 'dept'){
                this.courseInfoExportForm.Zydm = []
                this.$api.scoreManage.query.failSubject.loadExportMajorCombo({
                    data: formData,
                })
                    .then((res) => {
                        this.courseInfoExportComboOption.major = res.data.data
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }

            formData.append('gradeCode', this.courseInfoExportForm.Njdm);
            formData.append('majorCode', this.courseInfoExportForm.Zydm);

            this.$api.scoreManage.query.failSubject.loadExportClassCombo({
                data: formData,
            })
                .then((res) => {
                    this.courseInfoExportComboOption.class = res.data.data
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        courseInfoExport() {
            this.$refs["courseInfoExportForm"].validate((valid) => {
                if (valid) {
                    $('#loadingMask').show();
                    const paramMap = {
                        'Xn': this.courseInfoExportForm.Xn,
                        'Xq': this.courseInfoExportForm.Xq,
                        'Xz': this.courseInfoExportForm.Xz,
                        'Xb': this.courseInfoExportForm.Xbdm.join(','),
                        'Zy': this.courseInfoExportForm.Zydm.join(','),
                        'Nj': this.courseInfoExportForm.Njdm.join(','),
                        'Bj': this.courseInfoExportForm.Bjdm.join(','),
                    }
                    this.$api.teachingPlanImplementation.teachingPlanImplementation.courseInfoExport({
                        responseType: "blob",
                        data: paramMap
                    }).then((res) => {
                        const _this = this;
                        const resultData = res.data;

                        const fileReader = new FileReader();
                        fileReader.onload = function () {
                            if (resultData.type == 'application/json') {
                                const jsonData = JSON.parse(fileReader.result); // 说明是普通对象数据，后台转换失败
                                showNotify('错误', jsonData.msg, 'error', 3000);
                            } else {
                                const fileName = decodeURI(res.headers['content-disposition'].split(
                                    'fileName=')[1]);
                                _this.downloadFileByBlob(resultData, fileName);
                            }
                        };
                        fileReader.readAsText(resultData);
                    }).catch((err) => {
                        console.log(err);
                    }).finally(() => {
                        $('#loadingMask').hide();
                    });
                } else {
                    return false;
                }
            });
        },
        downloadFileByBlob(data, fileName) {
            let blob = new Blob([data], {
                type: "application/ms-excel;charset=utf-8"
            });

            //浏览器兼容，Google和火狐支持a标签的download，IE不支持
            if (window.navigator && window.navigator.msSaveBlob) {
                window.navigator.msSaveBlob(blob, fileName);
            } else {
                let url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.setAttribute("href", url);
                link.setAttribute("download", fileName);
                link.click();
                link.remove();
                URL.revokeObjectURL(url);
            }
        },
        auditStateFormatter(row) {
            let str = '';
            if (row.zxqkshzt === '0') {
                str = '待审核';
            } else if (row.zxqkshzt === '1') {
                str = '审核中';
            } else if (row.zxqkshzt === '2') {
                str = '审核通过';
            } else if (row.zxqkshzt === '3') {
                str = '审核驳回';
            }
            return str;
        },
        //审状态列样式处理
        handleCellStyle({row, column, rowIndex, columnIndex}) {
            let cellStyle;

            if (columnIndex === 4) {
                switch (row.zxqkshzt) {
                    case '2':
                        cellStyle = 'color: #00FF40 !important;';
                        break;
                    case '3':
                        cellStyle = 'color: #FE2E2E !important;';
                        break;
                    default:
                        cellStyle = '';
                }

                return cellStyle;
            }
        },
        initParam() {
            const paramMap = {
                'name': 'combo_Info'
            }
            this.$api.teachingPlanImplementation.teachingPlanImplementation.initOption({
                data: paramMap
            }).then(response => {
                this.xnxqInfo = response.data.data.xnxq;
                this.xnInfo = response.data.data.xn;
                this.courseInfoExportComboOption.dept = response.data.data.dept;
                this.courseInfoExportComboOption.major = response.data.data.major;
                this.courseInfoExportComboOption.grade = response.data.data.grade;
                this.courseInfoExportComboOption.class = response.data.data.class;
                this.exportForm.Xnxqbm = this.xnxqInfo[0].comboValue;
                this.deptOption();
            }).catch(error => {
                console.log(error);
            });
        },
        deptOption() {
            const paramMap = {
                'name': 'combo_Info'
            }
            this.$api.teachingPlanImplementation.teachingPlanImplementation.deptOption({
                data: paramMap
            }).then(response => {
                this.deptInfo = response.data.data.dept;
                this.majorOption();
            }).catch(error => {
                console.log(error);
            });
        },
        majorOption() {
            const paramMap = {
                'Xbdm': this.queryForm.Xbdm + '',
            }
            this.$api.teachingPlanImplementation.teachingPlanImplementation.majorOption({
                data: paramMap
            }).then(response => {
                this.majorInfo = response.data.data.major;
            }).catch(error => {
                console.log(error);
            });
        },
        classOption() {
            const paramMap = {
                'Xbdm': this.queryForm.Xbdm + '',
                'Zydm': this.queryForm.Zydm + '',
            }
            this.$api.teachingPlanImplementation.teachingPlanImplementation.classOption({
                data: paramMap
            }).then(response => {
                this.classInfo = response.data.data.class;
            }).catch(error => {
                console.log(error);
            });
        },
        deptChange(val) {
            this.queryForm.Xbdm = val;
            this.queryForm.Zydm = "";
            this.queryForm.Bjdm = "";
            this.majorOption();
            this.classOption();
        },
        majorChange(val) {
            this.queryForm.Zydm = val;
            this.queryForm.Bjdm = "";
            this.classOption();
        },
        queryList() {
            this.tableLoading = true;
            this.queryForm.pageNum = this.currentPage;
            this.queryForm.rowNum = this.limit;

            this.$api.teachingPlanImplementation.teachingPlanImplementation.list({
                data: this.queryForm,
            }).then((response) => {
                this.total = response.data.data.total;
                this.tableData = response.data.data.list;
                this.tableLoading = false;
                if (this.tableData.length > 0) {
                    this.totalLevel = this.tableData[0].totalLevel;
                }

                if (this.skjhzbbh != '') {
                    for (let i = 0; i < this.tableData.length; i++) {
                        if (this.skjhzbbh == (this.tableData[i].skjhzbbh + '_KKJHZXQK')) {
                            this.auditLevel = this.tableData[i].auditLevel;
                            this.auditState = this.tableData[i].zxqkshzt;
                            this.auditAuth = this.tableData[i].auditAuth;
                        }
                    }
                }
            }).catch((error) => {
                this.tableLoading = false;
                console.log(error);
            });
        },
        handleFilter() {
            this.currentPage = 1;
            this.queryList();
        },
        handleReset() {
            this.limit = 10;
            this.currentPage = 1;
            this.queryForm.Xnxqbm = null;
            this.queryForm.Xbdm = null;
            this.queryForm.Zydm = null;
            this.queryForm.Bjjc = null;
            this.queryForm.Zxqkshzt = null;
            this.tableLoading = false;
            this.queryList();
        },
        handlePageChange(val) {
            this.currentPage = val;
            this.queryList();
        },
        handleCurrentChange(val) {
            this.selectRowData = val;
        },
        handleSizeChange(val) {
            this.kkjhlimit = val;
            this.kkjhcurrentPage = 1;
            this.showKKJHInfo();
        },
        kkjhPageChange(val) {
            this.kkjhcurrentPage = val;
            this.showKKJHInfo();
        },
        kkjhCurrentChange(val) {
            //this.selectRowData = val;
        },
        kkjhSizeChange(val) {
            this.kkjhlimit = val;
            this.kkjhcurrentPage = 1;
            this.showKKJHInfo();
        },
        showKKJHInfo(rowData) {
            this.selectRowData = rowData;
            this.skjhzbbh = rowData.skjhzbbh + '_KKJHZXQK';
            this.auditLevel = rowData.auditLevel;
            this.auditState = rowData.zxqkshzt;
            this.auditAuth = rowData.auditAuth;

            if (this.selectRowData == null) {
                this.$alert("请先选择一条记录", "提示", {
                    confirmButtonText: "确定",
                });
                return;
            }

            this.dialogTitle = rowData.bjjc;
            this.dialogVisible = true;

            this.tableLoading = true;
            const paramMap = {
                'Skjhzbbh': rowData.skjhzbbh,
                'pageNum': this.kkjhcurrentPage,
                'rowNum': this.kkjhlimit,
            }
            this.$api.teachingPlanImplementation.teachingPlanImplementation.kkjhlist({
                data: paramMap,
            }).then((response) => {
                this.kkjhtotal = response.data.data.total;
                this.kkjhData = response.data.data.list;
                this.tableLoading = false;
            }).catch((error) => {
                this.tableLoading = false;
                console.log(error);
            });
        },
        closeDialog() {
            this.dialogVisible = false;
            this.skjhzbbh = '';
        },
        //查询审核调用参数
        queryAuditParam() {
            const pageName = this.$route.path.substring(this.$route.path.lastIndexOf("/") + 1);

            this.$api.common.audit.auditParam({
                data: {pageName: pageName},
            }).then((res) => {
                this.auditParam = res.data.data.auditParam;
                this.queryForm.itemCode = this.auditParam;
                this.queryList();
            }).catch((err) => {
                console.log(err);
            });
        },
        auditRec() {
            this.detailDialogTitle = this.numarray[parseInt(this.auditLevel) - 1] + '级审核';
            this.detailDialogTop = '250px';
            this.detailDialogVisible = true;
            this.auditAreaVisible = true;
        },
        //显示审核详情列表
        showAuditList() {
            this.auditListDialogVisible = true;
        },
        //审核后回调函数
        auditCallback(auditInfo) {
            this.detailDialogVisible = false;
            if (auditInfo.auditLevel == this.totalLevel && auditInfo.auditState == "1") {//最后一级审核通过
                this.updateAuditState(auditInfo);
            } else if (auditInfo.auditState == "2") {//审核驳回
                this.updateAuditState(auditInfo);
            } else {
                this.queryList();
            }
        },
        //完成审核后更新授课计划主表执行情况审核状态
        updateAuditState(auditInfo) {
            const paramMap = {
                'Skjhzbbh': auditInfo.relatedCode.replace('_KKJHZXQK', ''),
                'Zxqkshzt': auditInfo.auditState,
            }
            this.$api.teachingPlanImplementation.teachingPlanImplementation.updateAuditState({
                data: paramMap,
            }).then((response) => {
                this.queryList();
                let state = response.data.data.state;
                if (state == 'fail') {
                    this.$notify({
                        title: "失败",
                        message: "执行情况审核状态更新失败",
                        type: "error",
                        duration: 3000,
                    });
                }
            }).catch((error) => {
                this.$notify({
                    title: "错误",
                    message: error,
                    type: "error",
                    duration: 3000,
                });
            });
        },
        showExport() {
            this.exportDialogVisible = true;
        },
        closeExportDialog() {
            this.exportForm.Xnxqbm = '';
            this.exportForm.Xnxqmc = '';
            this.exportForm.Xbdm = '';
            this.exportForm.Zydm = '';
            this.exportForm.Bjdm = '';
            this.exportDialogVisible = false;
        },
        //导出开课计划执行情况表
        teachingPlanExport() {
            $('#loadingMask').show();

            let obj = {};
            obj = this.xnxqInfo.find((item) => {
                return item.comboValue === this.exportForm.Xnxqbm;//筛选出匹配数据
            });
            this.exportForm.Xnxqmc = obj.comboName;

            const paramMap = {
                'Xnxqbm': this.exportForm.Xnxqbm,
                'Xnxqmc': this.exportForm.Xnxqmc,
                'Xbdm': this.exportForm.Xbdm + '',
                'Zydm': this.exportForm.Zydm + '',
                'Bjdm': this.exportForm.Bjdm + '',
            }
            this.$api.teachingPlanImplementation.teachingPlanImplementation.teachingPlanExport({
                data: paramMap,
                responseType: "blob",
            }).then((response) => {
                if (response.data.size == 0) {
                    this.$notify({
                        title: '提醒',
                        message: "查询不到开课计划信息",
                        type: 'warning',
                        duration: 3000,
                    });
                    $('#loadingMask').hide();
                } else {
                    const content = response.data;
                    const blob = new Blob([content]);

                    let year = new Date().getFullYear();//年
                    let month = new Date().getMonth() + 1;//注意！月份是从0月开始获取的，所以要+1;
                    let day = new Date().getDate();//日
                    //拼接日期
                    let yearMD = year + (month >= 10 ? month : '0' + month) + (day >= 10 ? day : '0' + day);

                    const fileName = this.exportForm.Xnxqmc + " 开课计划执行情况表" + yearMD + ".xlsx";
                    if ("download" in document.createElement("a")) {
                        // 非IE下载
                        const elink = document.createElement("a");
                        elink.download = fileName;
                        elink.style.display = "none";
                        elink.href = URL.createObjectURL(blob);
                        document.body.appendChild(elink);
                        elink.click();
                        URL.revokeObjectURL(elink.href); // 释放URL 对象
                        document.body.removeChild(elink);
                    } else {
                        // IE10+下载
                        navigator.msSaveBlob(blob, fileName);
                    }
                    $('#loadingMask').hide();
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        getCurrentFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
    },
};
</script>

<style scoped>
.kkjhTable >>> .el-table__header-wrapper {
    height: 72px;
}

.kkjhTable >>> .el-table__body-wrapper {
    height: calc(100% - 72px) !important;
}

.maskStyle {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: none;
    background-color: #000000;
    filter: alpha(opacity=60);
    -moz-opacity: 0.6;
    opacity: 0.6;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 100;
}

.maskFont {
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    width: 260px;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -10px;
    margin-left: -115px;
}
</style>



// WEBPACK FOOTER //
// teachingPlanImplementation.vue?97cfb1dc